
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.977 3.166H2.852C1.65 3.166.664 4.423.664 5.959v9.414c0 1.536.985 2.793 2.188 2.793h9.125c1.204 0 2.188-1.257 2.188-2.793V5.959c0-1.564-.984-2.793-2.188-2.793zM19.044 4.701a.998.998 0 00-.372.196L15.258 7.41v6.48l3.435 2.514c.635.475 1.423.196 1.795-.614.11-.252.175-.531.175-.838V6.32c0-1.033-.766-1.871-1.62-1.62z"}})])
          )
        }
      }
    